import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

type BreadcrumbPathStyleProps = {
  isInteractive: boolean;
};

const BREADCRUMB_PATH_INTERACTIVE = css`
  &:not(:last-of-type) {
    color: ${theme.font.colors.primary};
  }

  &:last-of-type {
    color: ${theme.font.colors.default};
  }
`;

const BREADCRUMB_PATH_DEFAULT = css`
  color: ${theme.font.colors.default};
`;

export const BreadcrumbPathStyles = {
  breadcrumbPathStyle: ({ isInteractive }: BreadcrumbPathStyleProps) =>
    isInteractive ? BREADCRUMB_PATH_INTERACTIVE : BREADCRUMB_PATH_DEFAULT,
};
